export const BOOKMAKERS_BY_REGION = {
  AU: ['Bet365', 'BetRight', 'Ladbrokes', 'PalmerBet', 'NextBet', 'Pointsbet', 'Sportsbet', 'TAB', 'Dabble', 'Unibet', 'TABtouch', 'Betmakers', 'Betr', 'PuntersTech', 'BetCloud', 'Amused', 'ApolloTech', 'GenWeb', 'AllBets', 'PickleBet'],
  US: ['BetMGM', 'BetParx', 'DraftKings', 'FanDuel', 'theScoreBet', 'Fanatics', 'Fliff', 'Bovada'],
  EU: ['Pinnacle'],
  // Prediction-market exchanges, kept OUT of the country groups on purpose:
  // their prices are RAW top-of-book and carry a taker fee (Kalshi 0.07 x p x (1-p),
  // Polymarket sports 0.05 x p x (1-p)), so a headline price is NOT what you net.
  // Their outcomes also carry `liquidity` / `size` / `alt_prices`, which no
  // bookmaker sends - the top level can be a few dollars deep. NFL only today.
  EXCHANGE: ['Kalshi', 'Polymarket'],
}

export const ALL_BOOKMAKERS = [...BOOKMAKERS_BY_REGION.AU, ...BOOKMAKERS_BY_REGION.US, ...BOOKMAKERS_BY_REGION.EU, ...BOOKMAKERS_BY_REGION.EXCHANGE]

const LOGO_BASE = 'https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images'

export const BOOKMAKER_LOGOS = {
  'Bet365':      `${LOGO_BASE}/Bookie_Logos/BET365.png`,
  'BetRight':    `${LOGO_BASE}/Bookie_Logos/BETRIGHT.jpg`,
  'Ladbrokes':   `${LOGO_BASE}/Bookie_Logos/LADBROKES.png`,
  'PalmerBet':   `${LOGO_BASE}/Bookie_Logos/PALMERBET.jpg`,
  'NextBet':     `${LOGO_BASE}/Bookie_Logos2/NextBetLogo.png`,
  'Pointsbet':   `${LOGO_BASE}/Bookie_Logos2/POINTSBETWEBSITE.png`,
  'Sportsbet':   `${LOGO_BASE}/Bookie_Logos/SPORTSBET.png`,
  'TAB':         `${LOGO_BASE}/Bookie_Logos/TAB.jpg`,
  'Dabble':      `${LOGO_BASE}/Bookie_Logos/DABBLE.png`,
  'Unibet':      `${LOGO_BASE}/Bookie_Logos/UNIBET.png`,
  'TABtouch':    `${LOGO_BASE}/Bookie_Logos2/tabtouchnew.png`,
  'Betmakers':   `${LOGO_BASE}/Bookie_Logos/BetM.jpeg`,
  'Betr':        `${LOGO_BASE}/Bookie_Logos/BETR.jpg`,
  'PuntersTech': `${LOGO_BASE}/Bookie_Logos2/PuntersTech.png`,
  'BetCloud':    `${LOGO_BASE}/Bookie_Logos2/BetCloud.png`,
  'Amused':      `${LOGO_BASE}/Bookie_Logos2/Amused.png`,
  'ApolloTech':  `${LOGO_BASE}/Bookie_Logos2/ApolloTech.png`,
  'GenWeb':      `${LOGO_BASE}/Bookie_Logos2/GenWeb.png`,
  'AllBets':     `${LOGO_BASE}/Bookie_Logos2/allbetsnew.jpg`,
  'PickleBet':   `${LOGO_BASE}/Bookie_Logos2/PickleBet.png`,
  'BetMGM':      `${LOGO_BASE}/Bookie_Logos/BETMGM.png`,
  'BetParx':     `${LOGO_BASE}/Bookie_Logos/BETPARX.png`,
  'DraftKings':  `${LOGO_BASE}/Bookie_Logos/DRAFTKINGS.jpg`,
  'FanDuel':     `${LOGO_BASE}/Bookie_Logos2/FANDUEL.png`,
  'theScoreBet': `${LOGO_BASE}/Bookie_Logos2/thescorebet.png`,
  'Fanatics':    `${LOGO_BASE}/Bookie_Logos/FANATICS.jpg`,
  'Fliff':       `${LOGO_BASE}/Bookie_Logos/FLIFF.jpg`,
  'Bovada':      `${LOGO_BASE}/Bookie_Logos/BOVADA.png`,
  'Pinnacle':    `${LOGO_BASE}/Bookie_Logos/PINNACLE.jpeg`,
  // Exchanges. Mixed case, matching the uploaded filenames exactly - the
  // bucket is case-sensitive and a differently-cased name 404s silently.
  // Kalshi.png is really a JPEG and neither has an alpha channel, which is
  // fine: both render as solid tiles under the cells' 5px border-radius,
  // the same as BET365.png and FANATICS.jpg already do.
  'Kalshi':      `${LOGO_BASE}/Bookie_Logos2/Kalshi.png`,
  'Polymarket':  `${LOGO_BASE}/Bookie_Logos2/Polymarket.png`,
  // Racing feed books (Racing Odds page, 2026-10). Keyed by the EXACT name the
  // racing API sends, because every page looks logos up by exact name - so the
  // racing spellings of PointsBet / Picklebet get their own keys too.
  'SwiftBet':    `${LOGO_BASE}/Bookie_Logos/SwiftBet.jpg`,
  'ChaseBet':    `${LOGO_BASE}/Bookie_Logos/CHASEBET.png`,
  'ColossalBet': `${LOGO_BASE}/Bookie_Logos/ColossalBet.jpeg`,
  'EliteBet':    `${LOGO_BASE}/Bookie_Logos/Elitebet.png`,
  '123bet':      `${LOGO_BASE}/Bookie_Logos/123bet.png`,
  'Bet777':      `${LOGO_BASE}/Bookie_Logos/Bet777.webp`,
  'Neds':        `${LOGO_BASE}/Bookie_Logos/Neds.jpg`,
  'PointsBet':   `${LOGO_BASE}/Bookie_Logos2/POINTSBETWEBSITE.png`,
  'Picklebet':   `${LOGO_BASE}/Bookie_Logos2/PickleBet.png`,
}

// Logo for any bookmaker name whatever its casing ("PointsBet" / "Pointsbet").
// Prefer this for new code; BOOKMAKER_LOGOS[name] needs the exact key.
const LOGO_BY_KEY = Object.fromEntries(
  Object.entries(BOOKMAKER_LOGOS).map(([name, url]) => [name.toLowerCase().replace(/[^a-z0-9]/g, ''), url])
)
export const bookmakerLogo = (name) => LOGO_BY_KEY[String(name ?? '').toLowerCase().replace(/[^a-z0-9]/g, '')] ?? null
